import { render, staticRenderFns } from "./Workstation.vue?vue&type=template&id=65e7e5be&"
import script from "./Workstation.vue?vue&type=script&lang=js&"
export * from "./Workstation.vue?vue&type=script&lang=js&"
import style0 from "./Workstation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports